export default __webpack_public_path__ + "static/media/general_v_eng.385d8b76.png";